import React from "react";
import QRCode from "qrcode.react";

function QRCodeGenerator({ content }) {
  return (
    <div>
      <QRCode value={content} style={{ width: "90%", height: "90%" }} />
    </div>
  );
}

export default QRCodeGenerator;
